export default __webpack_public_path__ + "static/bystrouska-52714c5c82e609bfb525792db82e8834.png";